module.exports = __webpack_public_path__ + "img/contract.77c7c80f.svg";